"use client";

import NotFoundScreen from "screens/NotFoundScreen";

export default function GlobalError({ error }) {
  return (
    <html>
      <body>
        <NotFoundScreen />
      </body>
    </html>
  );
}
